import { styled } from '@linaria/react'
import { Button } from 'atoms/Button'
import { IconSC } from 'atoms/Icon'
import { TextBoxSC } from 'atoms/TextBox/TextBox.styled'
import { COLOR, FIXED_INDENTS } from 'vars/index'

export const MenuAnchorSC = styled.div`
  position: relative;
`

export const ContentActionMenuRootSC = styled.div`
  position: absolute;
  right: var(${FIXED_INDENTS.INDENT_20});
  top: var(${FIXED_INDENTS.INDENT_20});
  z-index: 4;
`

export const ContentActionMenuTriggerSC = styled(Button)`
  &[data-arcana-button='true'] {
    border-radius: 50%;
    height: 32px;
    min-width: 32px;
    padding: 0;
    width: 32px;
    background: var(${COLOR.SURFACE_OPACITY_DARK_60});
  }

  &[data-arcana-button='true'][aria-expanded='true'],
  &:hover {
    ${IconSC} {
      color: var(${COLOR.TEXT_ICON_PRIMARY});
    }
  }
`

export const ContentActionMenuListSC = styled.div`
  background: var(${COLOR.SURFACE_DARK_4});
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 32px);
  padding: var(${FIXED_INDENTS.INDENT_30}) 0;
  position: fixed;
  left: 0;
  top: 0;
  width: min(360px, calc(100vw - 32px));
  z-index: 20;
`

export const ContentActionMenuItemSC = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: var(${COLOR.TEXT_ICON_PRIMARY});
  cursor: pointer;
  display: flex;
  gap: var(${FIXED_INDENTS.INDENT_40});
  height: 48px;
  min-width: 0;
  padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_60});
  text-align: left;
  text-decoration: none;
  width: 100%;

  ${IconSC} {
    flex-shrink: 0;
  }

  ${TextBoxSC} {
    flex: 1;
    min-width: 0;
  }

  &:hover {
    background: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
  }
`

export const ContentActionMenuLinkSC = styled.a`
  align-items: center;
  background: transparent;
  border: 0;
  color: var(${COLOR.TEXT_ICON_PRIMARY});
  cursor: pointer;
  display: flex;
  gap: var(${FIXED_INDENTS.INDENT_40});
  height: 48px;
  min-width: 0;
  padding: var(${FIXED_INDENTS.INDENT_30}) var(${FIXED_INDENTS.INDENT_60});
  text-align: left;
  text-decoration: none;
  width: 100%;

  ${IconSC} {
    flex-shrink: 0;
  }

  ${TextBoxSC} {
    flex: 1;
    min-width: 0;
  }

  &:hover {
    background: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
  }
`
